import React, { useState } from 'react';
import { IoChevronDown } from 'react-icons/io5';
import '../../sass/components/_faq.scss';

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqData = [
    {
      question: "When was Kihi Enterprises established and where is it located?",
      answer: "Kihi Enterprises was established in the year 2020 and is located at Pai Nagar, Borivali (West), Mumbai, Maharashtra. We are strategically positioned to serve customers across Mumbai and the surrounding regions."
    },
    {
      question: "What type of business structure is Kihi Enterprises?",
      answer: "Kihi Enterprises operates as a Sole Proprietorship based firm, specializing in the wholesale distribution of high-quality earthing and electrical protection products."
    },
    {
      question: "What are the main products offered by Kihi Enterprises?",
      answer: "Kihi Enterprises specializes in wholesaling a comprehensive range of earthing products including Earth Pit Cover, Earthing Electrode, Copper Lightning Arrester, Earthing Copper Strip, and many other electrical safety and grounding solutions."
    },
    {
      question: "What is Kihi Enterprises' primary business focus?",
      answer: "We are engaged as a foremost Wholesaler in the electrical earthing and protection industry, focusing on providing quality earthing solutions and electrical safety products to our clients across various sectors."
    },
    {
      question: "What types of copper products does Kihi Enterprises supply?",
      answer: "Kihi Enterprises supplies various copper-based earthing products including Copper Lightning Arresters for surge protection and Earthing Copper Strips for effective grounding systems, ensuring superior conductivity and long-lasting performance."
    }
  ];

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <h1 className="faq-title">Frequently Asked Question</h1>
      
      <div className="faq-list">
        {faqData.map((item, index) => (
          <div key={index} className="faq-item">
            <div 
              className="faq-question"
              onClick={() => toggleAccordion(index)}
            >
              <span className="question-text">{item.question}</span>
              <IoChevronDown 
                className={`chevron-icon ${openIndex === index ? 'rotated' : ''}`}
              />
            </div>
            {openIndex === index && (
              <div className="faq-answer">
                <p>{item.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faq;